import { Method } from 'state-line';
import BaseApi from './Base';

// 意见反馈
export default (server: string) => ({

  // 查询意见历史记录
  GetRecord: class extends BaseApi<{
    uid: string;
    currentPage?: number;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedback/list`;
  },

  // 查询意见类型
  GetFeedbackType: class extends BaseApi<{
    parentCode?: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedbackType/query`;
  },

  // 查询意见反馈类型新
  QueryFeedbackType: class extends BaseApi<{
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedbackType/queryNew`;
  },

  // 提交意见
  AddFeedback: class extends BaseApi<{
    // 类型编码
    typeCode: string;
    // 用户id
    uid: string;
    // 内容
    content: string;
    // 图片列表
    imageList?: {
      url: string;
      sortValue: string;
    }[];
    // 来源 1-APP设置页面 2-app扫描大屏二维码 11-微信扫描大屏二维码 12-care+ 13-商城小程序 14-H5其它方式打开 21-帖子反馈
    subSource: string;
    // 设备名
    device: string;
    // 串号
    sn: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedback/add`;
  },

  // 获取设备列表
  GetDeviceList: class extends BaseApi<{
  }> {
    method: Method = Method.Get;
    url = `${server}/api/device/mainData/list`;
  },

  // 获取绑定列表
  GetBindDeviceList: class extends BaseApi<{
    openId: string;
  }> {
    method: Method = Method.Get;
    url = `${server}/api/device/bind/list`;
  },

  // 查询意见详情
  GetDetail: class extends BaseApi<{
    feedbackNo: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedback/getInfoByFeedbackNo`;
  },
  // 根据typeCode查询分类名称
  GetContentByCode: class extends BaseApi<{
    code: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/feedbackType/getFeedbackTypeByCode`;
  },

  // 根据sn查询对应机型名称
  GetProductNameBySn: class extends BaseApi<{
    sn: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/api/device/getDeviceActivationData`;
  },
});
